import type { GridColDef } from "@mui/x-data-grid-premium";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DynamicGrid } from "../dynamicGrid";
import { REGISTRATION_METADATA_FIELDS, type GridViewRegistration } from "../api/registrations.types";
import { PersonIcon3, TriangleAlertIcon } from "./icons";

export const responsibleColumn = ({
  headerName,
  noResponsible,
}: {
  headerName: string;
  noResponsible: string;
}): GridColDef<GridViewRegistration> => ({
  ...DynamicGrid.requiredColDef({ headerName, field: REGISTRATION_METADATA_FIELDS.RESPONSIBLE }),
  width: 280,
  valueGetter: (_, row) =>
    row.responsible ? `${row.responsible.firstName} ${row.responsible.lastName}` : noResponsible,
  renderCell: ({ row }) => (
    <DynamicGrid.Cell withExtraSpacingTop={false}>
      {row.responsible ? (
        <DynamicGrid.TextCellContent
          value={`${row.responsible.firstName} ${row.responsible.lastName}`}
          Icon={PersonIcon3}
        />
      ) : (
        <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
          <TriangleAlertIcon size={14} color={theme => theme.palette.warning.main} />
          <Typography sx={{ fontSize: theme => theme.typography.pxToRem(14), color: "warning.dark" }}>
            {noResponsible}
          </Typography>
        </Stack>
      )}
    </DynamicGrid.Cell>
  ),
});
